var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 26.25H6.25C3.5 26.25 1.25 24 1.25 21.25V8.75C1.25 6 3.5 3.75 6.25 3.75H23.75C26.5 3.75 28.75 6 28.75 8.75V21.25C28.75 24 26.5 26.25 23.75 26.25Z",
    stroke: "#A35BB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.8751L19 13.875C19.875 14.375 19.875 15.6251 19 16.1251L13 19.125C12.125 19.5 11.25 18.8751 11.25 18.0001V12C11.25 11.125 12.25 10.5001 13 10.8751Z",
    stroke: "#A35BB1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.ed56af27c8817192b762a288302dd839.svg";
export { ForwardRef as ReactComponent };